import { Appointment, PatientProfile } from "@elixir/types";
import {
  CloseSaQuestionnaireListEvent,
  OpenHprHfrOnboardingWithAadharPresent,
} from "../../bridges";

export const SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG =
  "SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG";

export interface ShowGoogleReviewKnowMoreDialogEvent {
  type: typeof SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG;
  docid: string;
}

export const ADD_NEW_PT_APPT = "add-new-patient";
export interface ShowAddNewPatientPopoverEvent {
  type: typeof ADD_NEW_PT_APPT;
  docid?: string;
}

export const EXPORT_ALL_PT = "EXPORT_ALL_PT";

export interface ExportAllPtEvent {
  type: typeof EXPORT_ALL_PT;
}

export const INIT_MEDICAL_CERTIFICATE = "INIT_MEDICAL_CERTIFICATE";

export interface InitMedicalCertificateEvent {
  type: typeof INIT_MEDICAL_CERTIFICATE;
  ap: Appointment;
}

export const ON_PATIENT_EDIT_ACTION = "ON_EDIT_PATIENT";
export interface OnPatientEditEvent {
  type: typeof ON_PATIENT_EDIT_ACTION;
  a: Appointment;
}

export const OPEN_URL_IN_IFRAME_DIALOG = "OPEN_URL_IN_IFRAME_DIALOG";

export interface ToggleIframeActionDialogEvent {
  type: typeof OPEN_URL_IN_IFRAME_DIALOG;
  url: string;
}

export const ON_APPT_ACTION = "ON_APPT_ACTION";

export interface OnApptActionEvent {
  type: typeof ON_APPT_ACTION;
  a: Appointment;
  cId: string;
  dontAllowStartVisit?: boolean;
  isNotesMode?: boolean;
  openVideoCallWindow?: boolean;
}

export const ON_REQUEST_PAYMENT = "ON_REQUEST_PAYMENT";
export const BILLING_POPUP = "BILLING_POPUP";
export const ON_REQUEST_MEDICAL_RECORDS = "ON_REQUEST_MEDICAL_RECORDS";
export const ON_ADD_ADDRESS = "ON_ADD_ADDRESS";
export const ON_MR_UPLOAD = "ON_MR_UPLOAD";
export const ON_HPR_CREATED_SUCCESSFULLY = "ON_HPR_CREATED_SUCCESSFULLY";
export const ON_HFR_CREATED_SUCCESSFULLY = "ON_HFR_CREATED_SUCCESSFULLY";
export const CREATE_ABHA = "CREATE_ABHA";
export const ON_OPEN_TREATMENT_PLAN = "ON_OPEN_TREATMENT_PLAN";
export const ON_OPEN_ADMIT_PATIENT_DRAWER = "ON_OPEN_ADMIT_PATIENT_DRAWER";

export interface RequestPaymentEvent {
  type: typeof ON_REQUEST_PAYMENT;
  a: Appointment;
}

export interface BillPopupEvent {
  type: typeof BILLING_POPUP;
  data: {
    aid?: string | null;
    patient: PatientProfile;
    uhid?: string | null;
    clinicId: string;
    source:
      | "apt-queue"
      | "apt-queue-view-receipts"
      | "new-patients"
      | "all-patients"
      | "prescription"
      | "billing-queue";
  };
}

export interface RequestMedicalRecordsEvent {
  type: typeof ON_REQUEST_MEDICAL_RECORDS;
  a: Appointment;
}

export interface AddAddressEvent {
  type: typeof ON_ADD_ADDRESS;
  a: Appointment;
}

export const ON_BILL_PATIENT = "ON_BILL_PATIENT";

export interface BillPatientEvent {
  type: typeof ON_BILL_PATIENT;
  a: Appointment;
}

export const ON_REFER_PATIENT = "ON_REFER_PATIENT";

export interface ReferPatientEvent {
  type: typeof ON_REFER_PATIENT;
  a: Appointment;
}

export const ON_SHOW_SA = "ON_SHOW_SA";

export interface OnShowSAtEvent {
  type: typeof ON_SHOW_SA;
  a?: Appointment;
  sa_id?: string;
  sa_ids?: string[];
}

export const ON_CREATE_TEMPLATE = "ON_CREATE_TEMPLATE";

export interface OnCreateTemplateEvent {
  type: typeof ON_CREATE_TEMPLATE;
  a: Appointment;
}

export const ON_ORDER_MEDICINE = "ON_ORDER_MEDICINE";
export const ON_BOOK_LAB_TEST = "ON_BOOK_LAB_TEST";

export interface OnOrderMedicineEvent {
  type: typeof ON_ORDER_MEDICINE;
  a: Appointment;
}

export interface OnBookLabTestEvent {
  type: typeof ON_BOOK_LAB_TEST;
  a: Appointment;
}

export const ON_ENTER_VITALS = "ON_ENTER_VITALS";

export interface OnEnterVitalsEvent {
  type: typeof ON_ENTER_VITALS;
  a: Appointment;
}

export const ON_ADD_VACCINATION = "ON_ADD_VACCINATION";

export interface OnAddVaccination {
  type: typeof ON_ADD_VACCINATION;
  a: Appointment;
}

export const OPEN_GLOBAL_SEARCH = "OPEN_GLOBAL_SEARCH";

export interface OpenUniversalPatientSearch {
  type: typeof OPEN_GLOBAL_SEARCH;
}

export interface OnUploadMedicalRecordEvent {
  type: typeof ON_MR_UPLOAD;
  ptOid: string;
  source?: "file" | "camera";
}

export interface OnHprCreatedSuccessfully {
  type: typeof ON_HPR_CREATED_SUCCESSFULLY;
}

export interface OnHfrCreatedSuccessfully {
  type: typeof ON_HFR_CREATED_SUCCESSFULLY;
}

export interface OpenCreateAbhaFlow {
  type: typeof CREATE_ABHA;
  a: Appointment;
}

export interface OnOpenTreatmentPlan {
  type: typeof ON_OPEN_TREATMENT_PLAN;
  a: Appointment;
}

export interface OnOpenAdmitPatientDrawerEvent {
  type: typeof ON_OPEN_ADMIT_PATIENT_DRAWER;
  a: Appointment;
}

export type Events =
  | ShowGoogleReviewKnowMoreDialogEvent
  | InitMedicalCertificateEvent
  | ToggleIframeActionDialogEvent
  | OnApptActionEvent
  | ExportAllPtEvent
  | RequestPaymentEvent
  | BillPopupEvent
  | BillPatientEvent
  | ReferPatientEvent
  | OnShowSAtEvent
  | OnCreateTemplateEvent
  | OnOrderMedicineEvent
  | OnBookLabTestEvent
  | OnEnterVitalsEvent
  | RequestMedicalRecordsEvent
  | AddAddressEvent
  | ShowAddNewPatientPopoverEvent
  | OnPatientEditEvent
  | OpenUniversalPatientSearch
  | OnUploadMedicalRecordEvent
  | OnHprCreatedSuccessfully
  | OnHfrCreatedSuccessfully
  | OpenCreateAbhaFlow
  | OpenHprHfrOnboardingWithAadharPresent
  | OnOpenTreatmentPlan
  | OnOpenAdmitPatientDrawerEvent
  | CloseSaQuestionnaireListEvent
  | OnAddVaccination;

export const REFRESH_APPT = "REFRESH_APPT";

export const HIDE_RENEWAL_STRIP = "REFERRAL_STRIP_HIDE";

export interface HideRenewalStripEvent {
  type: typeof HIDE_RENEWAL_STRIP;
  shouldHide: boolean;
}

export interface RefreshApptEvent {
  type: typeof REFRESH_APPT;
}

export type IncomingEvents = RefreshApptEvent | HideRenewalStripEvent;

export enum MESSAGE_TYPE {
  BOOK_APPPOINTMENT = "bkd_apt",
  CHECKIN_APPOINTMENT = "ckn_apt",
  CANCEL_APPOINTMENT = "cnl_apt",
  RESCHEDULE_APPOINTMENT = "res_apt",
  SELF_ASSESSMENT = "send_sa",
  GOOGLE_REVIEW = "ggl_rev",
  FOLLOWUP_REMINDER = "flw_rem",
  SEND_RECEIPT = "send_rcpt",
  SEND_PRESCRIPTION = "send_prscrpt",
  REQUEST_MEDICAL_RECORDS = "req_mr",
  SCHEDULE_APT_REMIDNER = "sch_apt_rem",
  SCHEDULE_FOLLOWUP_REMINDER = "sch_flw_rem",
  END_VISIT = "end_visit",
}
